import { Link } from "react-router-dom";
import logo from "../../assets/footer-logo.svg";

export default function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-wrapper">
            <div className="footer-logo">
              <Link path="/">
                <img src={logo} alt="footer-log" />
              </Link>
            </div>
            <div className="footer-info">
              <div className="footer-social-wrapper">
                <a href="https://www.tiktok.com/@smplsol" target="_blank">
                  <svg
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30.236 8.9492C28.5364 8.9492 26.9681 8.37639 25.7088 7.41008C24.2647 6.30237 23.2269 4.67747 22.8604 2.80464C22.7697 2.34189 22.7209 1.86437 22.7162 1.375H17.8611V14.8713L17.8552 22.2639C17.8552 24.2402 16.5902 25.9161 14.8363 26.5054C14.3273 26.6764 13.7777 26.7575 13.2053 26.7255C12.4748 26.6847 11.7901 26.4603 11.1951 26.0983C9.92874 25.3277 9.07021 23.9302 9.04694 22.3312C9.01029 19.8323 10.9961 17.795 13.4508 17.795C13.9353 17.795 14.4006 17.8754 14.8363 18.0216V14.3328V13.0066C14.3768 12.9376 13.9092 12.9013 13.4362 12.9013C10.7495 12.9013 8.23667 14.0374 6.44049 16.0843C5.08287 17.6311 4.26853 19.6044 4.14287 21.6738C3.97826 24.3922 4.95607 26.9763 6.8523 28.8828C7.13093 29.1629 7.4235 29.4225 7.72945 29.6623C9.35522 30.935 11.3428 31.625 13.4362 31.625C13.9092 31.625 14.3768 31.5895 14.8363 31.5204C16.7919 31.2257 18.5963 30.3149 20.0201 28.8828C21.7698 27.1238 22.7365 24.788 22.7469 22.3022L22.7221 11.2629C23.5567 11.9179 24.4693 12.4599 25.4489 12.8806C26.9723 13.5345 28.5875 13.866 30.2499 13.8652V10.2788V8.94801L30.236 8.9492Z"
                      fill="black"
                    />
                  </svg>
                </a>
                <a href="https://www.instagram.com/smpl_sol" target="_blank">
                  <svg
                    width="27"
                    height="27"
                    viewBox="0 0 27 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.52362 26.8352C9.5186 26.9565 11.5112 27.0042 13.5 26.9997C15.4885 27.0042 17.4813 26.9565 19.4764 26.8352C21.1565 26.7331 22.7504 26.1767 24.0792 25.0928C25.3592 24.0491 26.1623 22.6509 26.5619 21.0847C26.9313 19.638 26.9511 18.1836 26.9691 16.8698L26.9696 16.8439C26.9846 15.7329 26.9972 14.6182 26.9999 13.5024V13.5V13.4975C26.9972 12.3817 26.9846 11.2671 26.9696 10.156L26.9691 10.1301C26.9511 8.8164 26.9311 7.36204 26.5619 5.91509C26.1623 4.3489 25.3592 2.95086 24.0792 1.90709C22.7504 0.823356 21.1565 0.266932 19.4764 0.164782C17.4813 0.0434623 15.4885 -0.00434923 13.5 0.000308256C11.5112 -0.00434923 9.5186 0.0434623 7.52362 0.164782C5.84353 0.266932 4.24961 0.823356 2.92061 1.90709C1.64058 2.95086 0.837583 4.34892 0.437917 5.91507C0.0686252 7.36227 0.0487574 8.81685 0.030825 10.1306L0.030487 10.156C0.015277 11.2671 0.00260999 12.3817 0 13.4975V13.5V13.5024C0.00260999 14.6182 0.015277 15.7329 0.030487 16.8439L0.030825 16.8693C0.0487574 18.1831 0.0686252 19.6377 0.437917 21.0849C0.837583 22.6509 1.64058 24.0491 2.92061 25.0928C4.24961 26.1767 5.84353 26.7331 7.52362 26.8352ZM13.4975 24.8903C11.5447 24.8948 9.59623 24.848 7.65167 24.7297C6.36083 24.6512 5.20212 24.2315 4.25375 23.4582C3.37263 22.7396 2.78657 21.7572 2.48188 20.5634C2.18191 19.3878 2.15829 18.1725 2.13972 16.8151C2.12458 15.7074 2.11205 14.6029 2.10946 13.5C2.11205 12.397 2.12458 11.2925 2.13972 10.1848C2.15829 8.82738 2.18191 7.6122 2.48188 6.43662C2.78657 5.24266 3.37263 4.26031 4.25375 3.54182C5.2021 2.76848 6.36083 2.34876 7.65167 2.27026C9.59623 2.152 11.5447 2.10507 13.4975 2.10968H13.5H13.5024C15.455 2.10507 17.4037 2.152 19.3482 2.27026C20.6392 2.34876 21.7977 2.76845 22.7461 3.5418C23.6272 4.26029 24.2133 5.24266 24.518 6.4366C24.8179 7.61218 24.8415 8.82735 24.8602 10.1848C24.8753 11.2925 24.8879 12.3968 24.8906 13.5C24.8879 14.6031 24.8753 15.7074 24.8602 16.8151C24.8415 18.1725 24.8179 19.3878 24.518 20.5634C24.2133 21.7572 23.6272 22.7396 22.7461 23.4582C21.7977 24.2315 20.6392 24.6512 19.3482 24.7297C17.4037 24.848 15.455 24.8948 13.5024 24.8903H13.5H13.4975Z"
                      fill="black"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.94281 13.5005C6.94281 17.1219 9.87863 20.0577 13.5 20.0577C17.1214 20.0577 20.0572 17.1219 20.0572 13.5005C20.0572 9.87915 17.1214 6.94336 13.5 6.94336C9.87863 6.94336 6.94281 9.87915 6.94281 13.5005ZM13.5 17.9593C11.0374 17.9593 9.04118 15.9631 9.04118 13.5005C9.04118 11.0379 11.0374 9.0417 13.5 9.0417C15.9626 9.0417 17.9588 11.0379 17.9588 13.5005C17.9588 15.9631 15.9626 17.9593 13.5 17.9593Z"
                      fill="black"
                    />
                    <path
                      d="M22.3715 6.17273C22.3715 7.0248 21.6807 7.71559 20.8287 7.71559C19.9766 7.71559 19.2858 7.0248 19.2858 6.17273C19.2858 5.32068 19.9766 4.62988 20.8287 4.62988C21.6807 4.62988 22.3715 5.32068 22.3715 6.17273Z"
                      fill="black"
                    />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/smpl-sol"
                  target="_blank"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M28 27.9997V17.7445C28 12.7045 26.9151 8.85449 21.0351 8.85449C18.2 8.85449 16.31 10.3945 15.54 11.8645H15.47V9.30963H9.90509V27.9997H15.7151V18.7245C15.7151 16.2745 16.17 13.9296 19.18 13.9296C22.1551 13.9296 22.19 16.6945 22.19 18.8645V27.9645H28V27.9997Z"
                      fill="black"
                    />
                    <path
                      d="M0.454895 9.31055H6.26491V28.0006H0.454895V9.31055Z"
                      fill="black"
                    />
                    <path
                      d="M3.36001 0C1.505 0 0 1.505 0 3.36001C0 5.21501 1.505 6.75501 3.36001 6.75501C5.21501 6.75501 6.72001 5.21501 6.72001 3.36001C6.72001 1.505 5.21501 0 3.36001 0Z"
                      fill="black"
                    />
                  </svg>
                </a>
              </div>
              <div className="footer-info-text">
                <p>All Rights Reserved 2025</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
